// Webhooks.tsx
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../reducers';
import {
  addWebhookUrlThunk,
  removeWebhookUrlThunk,
} from '../../../team/teamSlice';
import Webhooks from './webhookComponents/Webhooks';

const TeamWebhooks = () => {
  const dispatch = useDispatch();
  const { team } = useSelector((state: RootState) => state);
  const { integrations, teamId } = team.selectedTeam || {};
  const teamWebhooks = integrations?.webhooks || [];

  const handleAddWebhook = async (name: string, url: string) => {
    if (!teamId) return;
    await dispatch(addWebhookUrlThunk({ teamId, name, url }));
  };

  const handleRemoveWebhook = async (url: string) => {
    if (!teamId) return;
    await dispatch(removeWebhookUrlThunk({ teamId, url }));
  };

  return (
    <Webhooks
      webhooks={teamWebhooks}
      onAddWebhook={handleAddWebhook}
      onRemoveWebhook={handleRemoveWebhook}
      note="Webhooks will only trigger if you record/upload the file to a folder other than &ldquo;My Recordings&rdquo; or if you move a file from &ldquo;My Recordings&rdquo; to another folder."
    />
  );
};

export default TeamWebhooks;
